import ConfirmDialog from "./ConfimDialog";

export default ConfirmDialog;
